module.exports = __webpack_public_path__ + "static/media/customer-cancel.1a466d43.mp3";